import request from "../../../helpers/request";

const deleteFacilityTariffs = async (tariffs) => {
  await Promise.all(
    tariffs.map((tariff) =>
      request.delete(
        `/RentPlace/tariff/${tariff.id}`,
        {},
        'При удалении тарифа произошла ошибка'
      )
    )
  );
};

export default deleteFacilityTariffs;
